import { PurchaseOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0822. 発注案件契約タスク関連書類なし更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/update_none_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  none_documents: boolean;
};

const updateNoneDocuments = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/update_none_documents`,
    props
  );
};

export const useUpdateNoneDocuments = () => {
  return useMutation({
    mutationFn: updateNoneDocuments,
  });
};
